import { apiRequest, ApiResponse } from './api';

export interface ChamadoMovimentacao {
  id: number;
  chamado_id: number;
  usuario_id: number;
  informacoes: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  usuario?: {
    id: number;
    nome: string;
    email: string;
    avatar: string;
  };
}

class ChamadoMovimentacaoService {
  private baseUrl = '/tickets';

  // Listar movimentações de um chamado
  async getByChamadoId(chamadoId: number): Promise<ApiResponse<ChamadoMovimentacao[]>> {
    return apiRequest.get<ChamadoMovimentacao[]>(`${this.baseUrl}/${chamadoId}/movimentacoes`);
  }

  // Criar nova movimentação
  async create(chamadoId: number, data: { informacoes: string }): Promise<ApiResponse<ChamadoMovimentacao>> {
    return apiRequest.post<ChamadoMovimentacao>(`${this.baseUrl}/${chamadoId}/movimentacoes`, data);
  }

  // Obter movimentação por ID
  async getById(chamadoId: number, id: number): Promise<ApiResponse<ChamadoMovimentacao>> {
    return apiRequest.get<ChamadoMovimentacao>(`${this.baseUrl}/${chamadoId}/movimentacoes/${id}`);
  }

  // Deletar movimentação
  async delete(chamadoId: number, id: number): Promise<ApiResponse<void>> {
    return apiRequest.delete<void>(`${this.baseUrl}/${chamadoId}/movimentacoes/${id}`);
  }
}

export const chamadoMovimentacaoService = new ChamadoMovimentacaoService();
export default chamadoMovimentacaoService;

